// Map of event types to specific image keywords for better relevance
const EVENT_IMAGES = {
  'conference': 'christian+conference',
  'camp': 'christian+youth+camp',
  'retreat': 'christian+retreat',
  'convention': 'christian+convention',
  'meeting': 'christian+meeting',
  'worship': 'worship+concert',
  'prayer': 'prayer+meeting',
  'bible': 'bible+study',
  default: 'christian+event'
};

export const getEventImage = (eventName, width = 600, height = 400) => {
  // Try to find a matching keyword in the event name
  const eventNameLower = eventName.toLowerCase();
  
  // Use specific Unsplash photo IDs for different event types
  // These are permanent URLs that won't change or disappear
  let photoId = '1540575467063-178a50c2df87'; // Default: conference hall
  
  if (eventNameLower.includes('camp')) {
    photoId = 'eOpewngf68w'; // Outdoor/camping
  } else if (eventNameLower.includes('retreat')) {
    photoId = 'IuLgi9PWETU'; // Peaceful/retreat setting
  } else if (eventNameLower.includes('youth')) {
    photoId = 'QckxruozjRg'; // Youth/young people
  } else if (eventNameLower.includes('worship') || eventNameLower.includes('concert')) {
    photoId = 'jG1z5o7NCq4'; // Worship/concert
  } else if (eventNameLower.includes('prayer')) {
    photoId = 'F2KRf_QfCqw'; // Prayer/meditation
  } else if (eventNameLower.includes('convention')) {
    photoId = '2EJCSULRwC8'; // Large gathering
  }
  
  // Use Unsplash's permanent photo URLs with dynamic sizing
  return `https://images.unsplash.com/photo-${photoId}?w=${width}&h=${height}&fit=crop&auto=format&q=80`;
};

// Predefined images for specific events if needed
const PREMIUM_IMAGES = {
  // Add specific event names and their image URLs here
  'Annual Conference': 'https://images.unsplash.com/photo-1505373876331-ff89baa02d8b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80',
  'Youth Camp': 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80',
  'Prayer Retreat': 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80',
  'UPCI General Conference': 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  'General Conference': 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
};

export const getPremiumEventImage = (eventName) => {
  return PREMIUM_IMAGES[eventName] || null;
};
